<div class="content-wrapper">
    <div class="content-wrapper">
        <div class="content-body">

            <!-- content-header component -->
            <app-content-header [contentHeader]="contentHeader"></app-content-header>

            <div class="card">

                <!-- TABELA DE DADOS -->
                <section id="ngx-datatable-inline-editing">
                    <!-- FUNCOES DA TABELA -->
                    <div class="row">
                        <div class="col-12">
                        </div>
                    </div>
                    <!-- FILTROS DA TABELA -->
                    <ng-template #customLoadingIndicator>
                        <div class="custom-loading-indicator">
                            <i class="fa fa-spinner fa-spin"></i>
                        </div>
                    </ng-template>

                    <!-- DATATABLE -->
                    <ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10" columnMode="force"
                        [reorderable]="false" [swapColumns]="false" [footerHeight]="50" [headerHeight]="120"
                        [loadingIndicator]="loadingPage" style="box-shadow: none" [rows]="rows" [scrollbarH]="true">

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Ano Vigente</h4>
                                <input type="search" placeholder="ID Contrato" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'dt_insert')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.ano_vigente}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4>Mês Vigente</h4>
                                <input type="search" placeholder="Data Fechamento" class="ml-25 form-control"
                                    (keyup)="textFilter($event, 'dt_insert')" />
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <span class="font-weight-bold">{{row.mes_vigente}}</span>
                            </ng-template>
                        </ngx-datatable-column>

                        <!-- COLUNA -->
                        <ngx-datatable-column name="Nome" prop="nome" [width]="60" [sortable]="false">
                            <ng-template let-column="column" ngx-datatable-header-template>
                                <h4 class="text-right mr-1">Ações</h4>
                            </ng-template>
                            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-value="value"
                                let-row="row">
                                <div class="d-flex align-items-center justify-content-end" style="float: right">
                                    <div ngbDropdown container="body">
                                        <a ngbDropdownToggle href="javascript:void(0);" class="hide-arrow"
                                            id="dropdownAcoes{{rowIndex}}" aria-haspopup="true" aria-expanded="false">
                                            <i data-feather="more-vertical" class="text-primary cursor-pointer mr-50"></i>
                                        </a>
                                        <div ngbDropdownMenu class="dropdown-menu-right"
                                            attr.aria-labelledby="dropdownAcoes{{rowIndex}}">
                                            <a routerLink="/fechamento/importar-broker/{{row.id_fechamento}}"
                                                ngbDropdownItem class="d-flex align-items-center">
                                                <i data-feather="upload" class="mr-50"></i> Importação de Brokers
                                            </a>
                                            <a routerLink="/fechamento/{{row.id_fechamento}}/chips-importados"
                                                ngbDropdownItem class="d-flex align-items-center">
                                                <i data-feather="list" class="mr-50"></i> Chips Importados
                                            </a>
                                            <a *ngIf="row.flg_upload == 1"
                                                routerLink="/fechamento/{{row.id_fechamento}}/clientes"
                                                ngbDropdownItem class="d-flex align-items-center">
                                                <i data-feather="file-text" class="mr-50"></i> Detalhamento & Faturas
                                            </a>
                                            <a *ngIf="row.flg_upload == 1 && podeVerVendas"
                                                routerLink="/fechamento/{{row.id_fechamento}}/vendas"
                                                ngbDropdownItem class="d-flex align-items-center">
                                                <i data-feather="dollar-sign" class="mr-50"></i> Vendas e Boletos
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ngx-datatable-column>

                    </ngx-datatable>
                </section>

            </div>
        </div>
    </div>
</div>